import { Image } from '@chakra-ui/react'
import React from 'react'
import Carousel from 'react-grid-carousel'

import partners from './content/partners.json'
import PhoneFrameWrapper from './content/phone-frame-wrapper'

const BrandsOnPhone = () => {
  return (
    <>
      <PhoneFrameWrapper>
        <Carousel
          cols={3}
          rows={4}
          gap={20}
          autoplay={1800}
          loop
          hideArrow
          showDots
          containerStyle={{ height: '400px', width: '260px' }}
          mobileBreakpoint={0}
        >
          {partners.map((a) => {
            return (
              <Carousel.Item key={a}>
                <Image src={a} height="60px" width="60px" borderRadius="8px" />
              </Carousel.Item>
            )
          })}
        </Carousel>
      </PhoneFrameWrapper>
    </>
  )
}

export default BrandsOnPhone
